<template>
  <div>
  <!-- subscriber lookup nav -->
    <nav v-if="!suppressSearchTextBox" class="navbar navbar-light bg-light secondary-navbar-light fixed-top fade-in my-3 my-lg-0 px-0" v-cloak  role="navigation">
      <div class="container-fluid d-flex justify-content-between">
        <form autocomplete="off" class="form-inline campaign-filter-form" role="search" id="filters" name="filters">
          <!-- email -->
          <div v-if="searchTypes.length==1" class="mt-2 mt-sm-0 mr-md-2 position-relative">
            <input id="email_lookup" @input="setFilterEmail" type="text" class="form-control form-control-sm" autocomplete="off" :value="filterEmail" placeholder="Lookup email" @keyup.delete="function() {if (!filterEmail) clearSearchResults();}"/>
          </div>
          <div v-else class="input-group input-group-sm mt-2 mt-sm-0 mr-md-2 position-relative">
            <div class="input-group-prepend">
              <div
                class="input-group-text dropdown-toggle"
                data-loading-text="..."
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <ul class="dropdown-menu">
                  <li class="dropdown-header">Primary search type</li> 
                  <template v-for="(item, idx) in searchTypes">
                  <li 
                    class="dropdown-item" 
                    :class="{'active': searchTypeIndex==idx}"
                    @click="searchTypeIndex=idx; focusControl('email_lookup')"
                  >
                    {{item.displayName}}
                  </li>
                  </template>
                </ul>
              </div>
            </div>

            <template v-if="searchTypes[searchTypeIndex].value=='email'">
              <input id="email_lookup" type="email" 
                class="form-control form-control-sm last-in-group" 
                :class="{'is-invalid': invalidEmail}"
                autocomplete="off" :value="filterEmail" 
                @input="setFilterEmail" required 
                placeholder="Lookup email" 
                @keyup.delete="function() {if ( !filterEmail ) clearSearchResults();}" 
                @change="validateEmail(filterEmail)" />
              <div class="invalid-tooltip">{{(filterEmail) ? 'Must be a valid email format' : 'Email is required'}}</div>
            </template>
            <template v-else-if="searchTypes[searchTypeIndex].value=='sms'">
              <input id="email_lookup" type="tel" 
                class="form-control form-control-sm last-in-group" 
                :class="{'is-invalid': invalidSMS}"
                autocomplete="off" :value="filterMobile" 
                @input="setFilterMobile" required
                placeholder="Lookup mobile number" @keyup.delete="function() {if ( !filterMobile ) clearSearchResults();}" 
                @change="validateMobileNumber(filterMobile)"/>

              <div class="invalid-tooltip">{{(filterMobile) ? 'Must be a valid mobile format' : 'Mobile is required'}}</div>
            </template>
          </div>
          <!-- /email -->

          <button class="btn btn-sm btn-primary mt-2 mt-md-0 mr-2 mr-md-3 d-none d-sm-block" @click.prevent="doLookup()">
            <span class="glyphicons glyphicons-search"></span>
          </button>

          <button aria-haspopup="true" class="form-control btn btn-primary btn-sm mt-2 d-block d-sm-none" @click.prevent="doLookup()" data-loading-text="...">
            Search
            <span class="glyphicons glyphicons-search"></span>
          </button>

        </form>

        <div v-cloak v-if="privs.DR && false" class="btn-group mt-2 mt-md-0 mr-2 mr-md-2">
          <button
            id="btnAdd"
            class="btn btn-dropdown-default btn-sm dropdown-toggle text-truncate"
            data-loading-text="..."
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            style="width: 150px;"
            :disabled="!filterEmail"
          >
            Other Actions
          </button>
          <ul class="dropdown-menu dropdown-menu-right">
            <li class="dropdown-item"
              @click="deleteRecords()"
              >Delete all records for <span class="font-italic">{{filterEmail}}</span></li>
            <li class="dropdown-item d-none"
              @click="deleteRecords()"
              >Generate PDF of all <span class="font-italic">{{filterEmail}}</span> records</li>
          </ul>

        </div>
      </div>
    </nav>
    <!-- subscriber lookup nav -->

    <!-- subscriber lookup panel -->
    <div id="lookup_panel" v-cloak 
      class="container-fluid fade-in main-content-margin-top flex-grow-1">
      <div class="row justify-content-around">
        <template v-if="filterEmail || filterMobile">
          <div :class="(showDemoEvents) ? 'col-8' : 'col'">
            <div class="card w-100">
              <template v-for="list in lookup.lists">
                <template v-if="list.isEntityBased">
                  <div class="card-header d-flex w-100 justify-content-between">
                    <h6 class="mb-0 mt-0">{{list.sub_account_display_name}}</h6>
                    <div class="d-inline-block align-bottom">
                      <small v-if="list.search_error">Error looking up subscriber details: <span class="text-warning">{{list.search_error}}</span></small>
                      <small v-else-if="!list.can_profile_lookup">This sub-account is not configured with subscriber lookup functionality</small>
                      <small v-else-if="list.can_profile_lookup && list.not_found">No subscriber record found in contact list</small>
                      <div v-show="list.searching" class="spinner float-right small text-gray">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </div>
                  <div class="card-body" v-if="list.can_profile_lookup && !list.not_found && !list.searching">
                    <div class="card-group fade-in">
                      <div v-if="list.user_attributes.length > 0" class="card">
                        <div class="card-body">
                          <h5 class="card-title">Attributes
                          </h5>
                          <h6 class="card-subtitle mb-2 text-muted small">
                            <span v-if="list.created_dt" class="font-weight-semibold">Added:</span> {{fullDate(list.created_dt)}}<br>
                            <span v-if="list.last_modified_dt" class="font-weight-semibold">Last modified:</span> {{fullDate(list.last_modified_dt)}}
                          </h6>
                          <p class="card-text">
                            <div v-for="userAttr in list.user_attributes">
                              <span class="font-weight-semibold">{{userAttr.display_name}}:</span> {{userAttr.value}}<br>
                            </div>
                          </p>
                        </div>
                      </div>
                      <template v-for="entity in list.entities">
                        <div class="card">
                          <div class="card-body">
                            <h5 class="card-title">{{entity.display_name}}
                              <button v-if="(privs.CO || privs.OE) && entity.optable" class="btn btn-xs btn-secondary ml-1" @click.prevent="updateEntity(entity,list)">Manage...</button>
                            
                            </h5>
                            <h6 class="card-subtitle mb-2 text-muted small">{{entity.display_name}} <span class="font-weight-semibold">{{lastSearch}}</span> belongs to:</h6>
                            <p class="card-text">
                              <div v-for="value in entity.values" v-if="value.optedIn">
                                {{value.name}}
                              </div>
                              <h6 v-else class="card-subtitle mb-2 text-muted small">This contact doesn't belong to any {{entity.display_name.toLowerCase()}}</h6>
                            </p>

                          </div>
                        </div>
                      </template>

                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="card-header d-flex w-100 justify-content-between">
                    <h6 class="mb-0 mt-0"><small class="text-muted">{{list.sub_account_display_name}}</small> {{list.list_name}}</h6>
                    <div class="d-inline-block align-bottom">
                      <small v-if="list.search_error_object && list.search_error_object.statusCode==502" class="text-warning">Error connecting to server. <a @click="retryLookupContactForList(list)" href="#">Retry Connection <span class="align-baseline glyphicons glyphicons-refresh"></span></a></small>
                      <small v-else-if="list.search_error">Error looking up subscriber details: <span class="text-warning">{{list.search_error}}</span></small>
                      <small v-else-if="list.can_profile_lookup && list.not_found">No subscriber record found in contact list</small>
                      <small v-else-if="!list.can_profile_lookup">This sub-account is not configured with subscriber lookup functionality</small>
                      <div v-show="list.searching" class="spinner float-right small text-gray">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </div>

                  <div class="card-body fade-in" v-if="list.can_profile_lookup && !list.not_found && !list.searching">
                    <div v-show="false && list.searching" class="rotator-container">
                      <div class="rotator">
                        <div><div><div><div></div></div></div><div><div><div></div></div></div></div>
                      </div>
                    </div>
                    <template v-for="(subscriber,index) in list.subscribers">
                      <hr v-show="index > 0">
                      <div>
                        <template v-if="list.channel=='email' || list.channel=='all'">
                          <template v-if="subscriber.email_opted_in != null || subscriber.email_opt_status != null">
                            <span class="font-weight-semibold">Opt-in status:</span> <span class="badge text-white mr-3" :class="[subscriber.email_opted_in ? 'bg-success' : 'bg-warning', subscriber.updating ? 'blinky-blink' : '']">{{ subscriber.email_opt_status || (subscriber.email_opted_in ? 'Subscribed' : 'Unsubscribed')}}</span>
                          </template>
                          <template v-if="subscriber.email_deliverable != null">
                            <span class="font-weight-semibold">Deliverable:</span> <span class="badge text-white mr-3" :class="subscriber.email_deliverable ? 'bg-success' : 'bg-warning'">{{subscriber.email_deliverable ? 'Deliverable' : 'Undeliverable'}}</span>
                          </template>
                        </template>

                        <template v-if="allowSMS && (list.channel=='sms' || list.channel=='all')">
                          <template v-if="subscriber.mobile_opted_in != null">
                            <span class="font-weight-semibold">SMS Opt-in:</span> <span class="badge text-white mr-3" :class="[subscriber.mobile_opted_in ? 'bg-success' : 'bg-warning', subscriber.updating ? 'blinky-blink' : '']">{{subscriber.mobile_opted_in ? 'Subscribed' : 'Unsubscribed'}}</span>
                          </template>
                          <template v-if="subscriber.mobile_deliverable != null">
                            <span class="font-weight-semibold">SMS Deliverable:</span> <span class="badge text-white" :class="subscriber.mobile_deliverable ? 'bg-success' : 'bg-warning'">{{subscriber.mobile_deliverable ? 'Deliverable' : 'Undeliverable'}}</span>
                          </template>
                        </template>

                          <div class="float-right">
                            <template v-if="list.channel=='email' || list.channel=='all'">
                              <button v-if="(privs.CO || privs.OE) && subscriber.email_opted_in && ! list.disable_optout" class="btn btn-xs btn-dropdown-default pf-unsub-email" @click.prevent="updateOptin(list,subscriber,false)">Unsubscribe from Email</button>
                              <button v-if="(privs.CO || privs.OE) && !subscriber.email_opted_in && ! list.disable_optin" class="btn btn-xs btn-dropdown-default pf-optin-email" @click.prevent="updateOptin(list,subscriber,true)">Opt-in to Email</button>
                            </template>

                            <template v-if="allowSMS && (list.channel=='sms' || list.channel=='all')">
                              <button v-if="(privs.CO || privs.OS) && subscriber.mobile_opted_in && ! list.disable_optout" class="btn btn-xs btn-dropdown-default ml-2 pf-unsub-sms" @click.prevent="updateOptin(list,subscriber,false, true)">Unsubscribe from SMS</button>
                              <button v-if="(privs.CO || privs.OS) && !subscriber.mobile_opted_in && ! list.disable_optin" class="btn btn-xs btn-dropdown-default ml-2 pf-optin-sms" @click.prevent="updateOptin(list,subscriber,true, true)">Opt-in to SMS</button>
                            </template>

                          </div>
                        
                      </div>
                      <div v-if="list.channel=='email' || list.channel=='all'">
                        <span class="font-weight-semibold">Email:</span> {{subscriber.email}}
                      </div>
                      <div v-if="allowSMS && (list.channel=='sms' || list.channel=='all')">
                        <span class="font-weight-semibold">Mobile:</span> {{subscriber.mobile_number}}
                      </div>
                      <div v-if="subscriber.created_dt"><span class="font-weight-semibold">Added to contact list:</span>{{fullDate(subscriber.created_dt)}}</div>
                      <div v-if="subscriber.last_modified_dt"><span class="font-weight-semibold">Last modified:</span> {{fullDate(subscriber.last_modified_dt)}}</div>
                      <div v-for="attr in subscriber.attrs">
                        <div>
                          <span class="font-weight-semibold">{{attr.display_name}}:</span> 
                          <span v-if="attr.value">{{attr.value}}</span>
                          <span v-else class="text-muted">&nbsp;&nbsp;&mdash;</span>
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
              </template>
            </div>
          </div>
          <div v-if="showDemoEvents" class="col-4">
            <h3 class="d-inline-block">Activity</h3>&nbsp;
            <div class="dropdown d-inline-block">
              <small class="text-muted dropdown-toggle cursor-pointer" data-toggle="dropdown">All time</small>
              <div class="dropdown-menu">
                <div class="dropdown-header">Choose time period</div>
                <a class="dropdown-item active" href="#">All time</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#">Last 30 days</a>
                <a class="dropdown-item" href="#">Last 60 days</a>
                <a class="dropdown-item" href="#">Last 90 days</a>
                <a class="dropdown-item" href="#">Last 180 days</a>
                <a class="dropdown-item" href="#">Last 12 months</a>
              </div>
            </div>
            <table class="table">
              <tbody>
                <tr>
                  <th class="align-middle">Emails Sent</th>
                  <td class="text-right pr-3"><h4 class="mb-0">154</h4></td>
                </tr>
                <tr class="text-danger">
                  <th class="align-middle">Spam Complaint</th>
                  <td class="align-middle pr-3 text-right small font-weight-semibold">{{lookupEvents.lastSpam}}</td>
                </tr>
                <tr class="text-warning">
                  <th class="align-middle">Delivery Bounces</th>
                  <td class="text-right pr-3"><h4 class="mb-0">2</h4></td>
                </tr>
                <tr class="text-warning">
                  <th class="align-middle">Last Bounce</th>
                  <td class="align-middle pr-3 text-right small font-weight-semibold">{{lookupEvents.lastBounce}}</td>
                </tr>
                <tr>
                  <th class="align-middle">Emails Opened</th>
                  <td class="text-right pr-3"><h4 class="mb-0">19</h4></td>
                </tr>
                <tr>
                  <th class="align-middle pb-0">Open Rate</th>
                  <td class="text-right pr-1 pb-0"><h4 class="mb-0">12.3<sup><small>%</small></sup></h4></td>
                </tr>
                <tr>
                  <td style="border-top: none;" class="pt-0 pb-1"></td>
                  <td style="border-top: none;" class="pt-0 pr-3 text-right small text-warning pb-1 font-weight-semibold">-2.1</td>
                </tr>
                <tr>
                  <th class="align-middle">Last Open</th>
                  <td class="align-middle pr-3 text-right small">{{lookupEvents.lastOpen}}</td>
                </tr>
                <tr>
                  <th class="align-middle">Emails Clicked</th>
                  <td class="text-right pr-3"><h4 class="mb-0">4</h4></td>
                </tr>
                <tr>
                  <th class="align-middle pb-0">Click Rate</th>
                  <td class="text-right pr-1 pb-0"><h4 class="mb-0">2.6<sup><small>%</small></sup></h4></td>
                </tr>
                <tr>
                  <td style="border-top: none;" class="pt-0 pb-1"></td>
                  <td style="border-top: none;" class="pt-0 pr-3 text-right small text-success pb-1 font-weight-semibold">+0.4</td>
                </tr>
                <tr>
                  <th class="align-middle">Last Click</th>
                  <td class="align-middle pr-3 text-right small">{{lookupEvents.lastClick}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-else>
          <div class="col-12 text-muted">
            Enter {{searchTypes[searchTypeIndex].displayName}} above to lookup subscriber details
          </div>
        </template>
      </div>
    </div>
    <EntityOptin ref="EntityOptin" />
  </div>
</template>
<script>
import {mapState} from 'vuex'
import DateFormatting from '@/mixins/date-formatting'
import SearchBar from '@/mixins/search-bar'
const queryString = require('query-string');
const findIndex = require('lodash/findIndex')
import {parseJSON} from 'date-fns'
import {zonedTimeToUtc,utcToZonedTime,format} from 'date-fns-tz'
import {fetchHandler,fetchCatcher} from '@/js/sageflo/ui-helpers.js'
import EntityOptin from './entity-optin'

export default {
  mixins: [DateFormatting,SearchBar],
  components: {EntityOptin},
  data: function(){ 
    return {
      lookup: {
        lists: []
      },
      lookupSettings: {
        canChangeContact: true,
        canChangeEmail: true,
        canChangeOptIn: true,
        canChangeOptOut: true,
        subscriber: -1,
        email_permission_status_: '',
        email_deliverability_status_: '',
        created_date_: '',
        modified_date_: '',
        isValidSearch: false,
        isSearching: true,
        errorMessage: '',
        new_email: '',
        sub_account_name: 'all',
        sub_account_display_name: 'All Accounts',
        accountIndex: -1,
      },
      lookupEvents: {
        lastSpam: moment().subtract(820, 'hours').format('ddd MMM-D-YYYY h:mm a z'),
        lastBounce: moment().subtract(87, 'days').format('ddd MMM-D-YYYY h:mm a z'),
        lastOpen: moment().subtract(122, 'hours').format('ddd MMM-D-YYYY h:mm a z'),
        lastClick: moment().subtract(183, 'hours').format('ddd MMM-D-YYYY h:mm a z'),
      },
      lastSearch: null,
    };
  },
  computed: {
    ...mapState({
      uiConfig: (state)=>state.user.uiConfig,
      privs: (state)=>state.user.privs,
      loading: (state)=>state.ui.loading,
      activeView: (state)=>state.ui.activeView,
      detailView: (state)=>state.ui.detailView,
      activeSubAccount: (state)=>state.ui.activeSubAccount,
      viewType: (state)=>state.ui.viewType,      
      emailsearchParams: (state)=>state.search.searchParams,
      filterEmail: (state)=>state.search.filterEmail,
      filterMobile: (state)=>state.search.filterMobile,
      resend: (state)=>state.search.resend,
      showDemoEvents: (state)=>state.search.showDemoEvents,
      qsParams: (state)=>state.search.qsParams,      
    }),
    suppressSearchTextBox() {
      return Boolean(this.qsParams && this.qsParams.simpleSearch);
    },
    allowSMS() {
      if (this.searchTypes.length > 1) {
        for (let type in this.searchTypes) {
          if (this.searchTypes[type].value=='sms') {
            return true;
          }
        }
      }

      return false; // default returns false is we don't find 'sms' in searchTypes above
    },
    isMobileLookup(){
      return (this.searchTypes[this.searchTypeIndex].value=='sms');
    }    
  },
  methods: {
    doLookup(){
      if (this.filterEmail || this.filterMobile) {
        
        if (this.isMobileLookup) {
          if (this.invalidSMS) {
            return;
          }
        } else if (this.invalidEmail) {
          return;
        }
        if (this.isMobileLookup){
          this.lastSearch = this.filterMobile; 
        } else {
          this.lastSearch = this.filterEmail;
        }
        this.populateLists();
        let lookedUp = false;
        for (let list of this.lookup.lists){
          if (list.can_profile_lookup
            && (this.activeSubAccount == null || this.activeSubAccount.id == list.sub_account_id )){
            this.lookupContactForList(list)
            lookedUp = true;
          }
        }
        if (lookedUp){
          let name = (this.isMobileLookup) ? "contact_lookup_sms":"contact_lookup_email";
          let props = {
          }
          this.$store.dispatch("track",{name:name,props:props})
        }

      }
    },
    clearSearchResults() {
      this.lookup.lists = [];
    },
    lookupContactForList(list){
      //TODO: pass mobile_number for mobile lookup
      let params = {}
      if (this.isMobileLookup) {
        params.mobile_number = this.filterMobile.replace(/\+/g, '');
      } else {
        params.email = this.filterEmail;
      }
      if (list.list_name){
        params.list = list.list_name;
      }
      let url = `/api/v2/sub-accounts/${encodeURIComponent(list.sub_account_name)}/contact?` + queryString.stringify(params);
      return fetch(url, {
          method: "GET",
          credentials: "include",
        })
      .then(async (response)=>{
        console.log("responseHandler")
        if (response.ok){
          let result = await response.json();
          //console.log(result);
          if (!list.isEntityBased) {
            list.subscribers = result.contacts;
          } else {
            list.entities = (result.entities) ? result.entities : [];
            list.user_attributes = (result.user) ? result.user : [];
            list.optins = (result.optins) ? result.optins : {};
            list.contact_id = result.contact_id;

            if (result.created_dt) {
              list.created_dt = result.created_dt;
            }

            if (result.last_modified_dt) {
              list.last_modified_dt = result.last_modified_dt;
            }

            console.log(result)

            // setup optins      
            for (let entityIdx in list.entities) {
              let type = list.entities[entityIdx].name;
              for (let itm of list.entities[entityIdx].values) {

                if (list.optins[type]) {
                  itm.optedIn = Boolean(findIndex(list.optins[type], function(o) { return o == itm.id }) != -1);
                } else {
                  itm.optedIn = false;  
                }
              }
            }
          }
          list.not_found = false;
          list.search_error = null;
          list.searching = false;
        } else {
          if (response.status == 404) {
            list.not_found = true;
          } else {
            let result = await response.json()
            list.search_error = result.message//response.result
          }
          list.searching = false;
        }
      })
      .catch(fetchCatcher(this));
    },
    retryLookupContactForList(list) {
      list.searching = true;
      this.lookupContactForList(list);
    },
    updateEntity(entity,subAccount) {

      let entityIdx = findIndex(subAccount.entities, (o)=>{return o.name==entity.name})

      let params = {
        entity: entity,
        contact_id: subAccount.contact_id,
        title: subAccount.entities[entityIdx].display_name,
        options: subAccount.entities[entityIdx].values,
        subAccount: subAccount
      }

      this.$refs.EntityOptin.showOptions(params);
    },
    async updateOptin(list,subscriber,optin, isMobile){
      subscriber.updating = true;

      let params = {
        contact_id: subscriber.contact_id,
        list: list.list_name,
        //TODO: for mobile, pass 'mobile' for type
        type: isMobile ? 'mobile' : 'email'
      };

      if (isMobile) {
        params.mobile_number = subscriber.mobile_number;
      } else {
        params.email = subscriber.email;
      }

      /*console.log(params);

      console.log(subscriber);*/

      let url = `/api/v2/sub-accounts/${encodeURIComponent(list.sub_account_name)}/contact/` + (optin ? 'opt-in' : 'opt-out');
      return fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      })
      .then(fetchHandler(this,{showAlert:true}))
      .then(async (response)=>{
        if (response.ok){
          let result = await response.json();
          if (isMobile) {
            subscriber.mobile_opted_in = optin;
          } else {
            subscriber.email_opted_in = optin;
            if (optin){
              //change what gets displayed for opt status, if it's available
              if (subscriber.email_opted_in_status){
                subscriber.email_opt_status = subscriber.email_opted_in_status;
              }
            } else {
              //change what gets displayed for opt status, if it's available
              if (subscriber.email_opted_out_status){
                subscriber.email_opt_status = subscriber.email_opted_out_status;
              }
            }
          }
          subscriber.updating = false;
          let title = null;
          if (list.list_name){
            title = `Subscriber status successfully changed in ${list.list_name}`;
          } else {
            title = `Subscriber status successfully changed`;
          }
          this.$eventBus.$emit("showStatus",{
            title:`Record Updated`,
            msg: title,
          });

          let name = (isMobile) ? "sms_":"email_";
          name += optin ? "optin" : "optout";
          let props = {
          }
          this.$store.dispatch("track",{name:name,props:props})

        }
      })      
      .catch(fetchCatcher(this));
    },
    async updateEntityOptin(subAccount,entity,contact_id,optin){
      optin.updating = true;

      let params = {
        contact_id: contact_id,
        entity: entity.name,
        entity_id: optin.id,
        email: this.filterEmail
      };

      let url = `/api/v2/sub-accounts/${encodeURIComponent(subAccount.sub_account_name)}/contact/` + (!optin.optedIn ? 'opt-in' : 'opt-out');

      return fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      })
      .then(fetchHandler(this,{showAlert:true}))
      .then(async (response)=>{
        if (response.ok){
          let result = await response.json();
          optin.optedIn = !optin.optedIn;
          optin.updating = false;

          let entityIdx = findIndex(subAccount.entities, (o)=>{return o.name==entity.name})

          let params = {
            entity: entity,
            contact_id: subAccount.contact_id,
            title: subAccount.entities[entityIdx].display_name,
            options: subAccount.entities[entityIdx].values,
            subAccount: subAccount
          }

          let optinIdx = findIndex(entity.values, (o)=>{return o.id==optin.id})
          if (optinIdx !=-1) {
            entity.values[optinIdx] = optin;
            this.$refs.EntityOptin.showOptions(params);
          }
          this.$forceUpdate();
          let name = "email_";
          name += optin ? "optin" : "optout";
          let props = {
          }
          this.$store.dispatch("track",{name:name,props:props})
        }
      })      
      .catch(fetchCatcher(this));
    },
    getChannelType(channel) {
      if (channel==undefined) {
        return 'all'
      } else {
        return channel;
      }
    },
    // TBD: reorganize to be subaccount based and determine whether the subaccount uses list-based or entity based lookup
    populateLists(){
      this.lookup.lists = [];
      for (let subAccount of this.uiConfig.sub_accounts){
        subAccount.searching = false;
        let subAccountCanLookup = false;
        if (subAccount.can_profile_lookup && subAccount.profile_platform_id && (this.activeSubAccount==null || this.activeSubAccount.id == subAccount.id)){
          let platformConfig = subAccount.platform_configs[subAccount.profile_platform_id];
          let isEntitySubAccount = Boolean(platformConfig && platformConfig.platform_functionality && platformConfig.platform_functionality.contact_lookup_type=='entity')
          subAccountCanLookup = true;
          if (this.isMobileLookup && platformConfig?.config.disable_sms_lookup){
            continue;
          }
          if (!this.isMobileLookup && subAccount.email_platform_id == null){
            //email lookup, but no email_platform_id means there should be no email lookup for this sub_account          
            continue;
          }
          if (!isEntitySubAccount && platformConfig && platformConfig.config && platformConfig.config.contact_list_config) {
            for (let listConfig of platformConfig.config.contact_list_config){
              if (listConfig.channel==undefined || listConfig.channel=='all' || (listConfig.channel=='sms' && this.isMobileLookup) || (listConfig.channel=='email' && !this.isMobileLookup)) {
                this.lookup.lists.push({
                  sub_account_id: subAccount.id,
                  sub_account_name: subAccount.sub_account_name,
                  sub_account_display_name: subAccount.sub_account_display_name,
                  list_name: listConfig.list_name,
                  can_profile_lookup: true,
                  not_found: false,
                  search_error: null,
                  subscribers: [],
                  channel: this.getChannelType(listConfig.channel),
                  searching: true,
                  disable_optin: platformConfig?.config.disable_optin,
                  disable_optout: platformConfig?.config.disable_optout,
                });

              }
            }
          } else if (platformConfig &&  platformConfig.config && !isEntitySubAccount){
            console.log(JSON.stringify(platformConfig))
            //no contact lists, just a single lookup for this platform account
            let channel = "email" //default channel
            if (platformConfig.platform_functionality && platformConfig.platform_functionality.channel){
              channel = platformConfig.platform_functionality.channel;
            }
            this.lookup.lists.push({
              sub_account_id: subAccount.id,
              sub_account_name: subAccount.sub_account_name,
              sub_account_display_name: subAccount.sub_account_display_name,
              can_profile_lookup: true,
              not_found: false,
              search_error: null,
              subscribers: [],
              channel: channel,
              searching: true,
              disable_optin: platformConfig?.config.disable_optin,
              disable_optout: platformConfig?.config.disable_optout,
            });
          } else if (platformConfig && platformConfig.config && isEntitySubAccount) {
            this.lookup.lists.push({
              isEntityBased: true,
              sub_account_id: subAccount.id,
              sub_account_name: subAccount.sub_account_name,
              sub_account_display_name: subAccount.sub_account_display_name,
              contact_id: null,
              entities: [],
              user_attributes: [],
              optins: {},
              can_profile_lookup: true,
              not_found: false,
              search_error: null,
              searching: true,
              subscriber: {},
              disable_optin: platformConfig?.config.disable_optin,
              disable_optout: platformConfig?.config.disable_optout,
            })
          } else {
            subAccountCanLookup = false;
          }
        }
        /*if (!subAccountCanLookup && (this.activeSubAccount==null || this.activeSubAccount.id == subAccount.id)){
          //can't profile lookup for this sub account
          this.lookup.lists.push({
            sub_account_id: subAccount.id,
            sub_account_name: subAccount.sub_account_name,
            sub_account_display_name:subAccount.sub_account_display_name,
            list_name:  subAccount.sub_account_display_name,
            can_profile_lookup: false,
            not_found: false,
            search_error: null,
            searching: false,
            subscribers: [],
          });
        }*/

      }
    }
  },  
  watch: {
    'activeSubAccount': {
      handler: function(newVal) {
        this.doLookup();
      },
      immedaite: true
    }
  },
  beforeRouteUpdate (to, from, next) {
    console.log("subscriber lookup before route update")

  } , 
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // access to component instance via `vm`
      console.log("before enter lookup route")
      vm.$store.commit("setActiveView","lookup");
      vm.doLookup()

    })
  },    
}
</script>
<style scoped>
  .blinky-blink {
    -webkit-animation-name: blinker;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: cubic-bezier(.5, 0, 1, 1);
    -webkit-animation-duration: 1.7s;
  }
  @-webkit-keyframes blinker {
    from { opacity: 1.0; }
    to { opacity: 0.0; }
  }
  .input-group input.last-in-group {
    border-top-right-radius: .2rem !important;
    border-bottom-right-radius: .2rem !important;
  }

  .card-group .card {
    border: none;
  }

  .card-group .card > .card-body {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
  }

</style>